// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"200a2408","864":"1eb5441c"}[chunkId] + ".chunk.js";
};